import axios from 'axios'

const API_BASE_URL = 'http://localhost:3002'

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export const healthCheck = () => apiClient.get('/health').then(r => r.data)
export const register = (data) => apiClient.post('/api/auth/register', data).then(r => r.data)
export const login = (data) => apiClient.post('/api/auth/login', data).then(r => r.data)
export const getProfile = () => apiClient.get('/api/auth/profile').then(r => r.data)

export default {
  healthCheck,
  register,
  login,
  getProfile
}
